import {IDisposableLike} from "../../Tools/Disposable/IDisposableLike";
import {ITemplateModel} from "../../Model/Template/ITemplateModel";

export class TemplateSujetEditor implements IDisposableLike {
    #model: ITemplateModel;
    #jqMainContainer: JQuery;
    #kForm: kendo.ui.Form;
    #jqFormContainer: JQuery;
    #isValid : boolean = true;

    constructor(option: ITemplateSujetEditor) {
        this.#model = option.model;
        this.#jqMainContainer = option.jqMainContainer;
    }
    
    public Init = async () => {
        await this.#buildHtml().then();
        await this.#buildForm().then();
    }
    
    #buildHtml = async () => {
        this.#jqFormContainer = $("<div></div>")
        .appendTo(this.#jqMainContainer)
            .css({height: "100%", width: "100%"});
    }
    
    #buildForm = async () => {
     this.#kForm = this.#jqFormContainer.kendoForm({
         formData: this.#model,
         orientation: "vertical",
         size: "small",
         items: [ {
             field: "SubjectTemplate",
             label: "Template Sujet",
             validation: {required: true},
         }, {
             field: "ExpediteurEmail",
             label: "E-mail expéditeur (par défaut)",
             validation: {
                 required: false,
                 // Champ optionnel : vide accepté, mais s'il est renseigné il
                 // doit être un e-mail valide (même règle que le back :
                 // TemplateModelValidator.CheckEmail).
                 expediteurEmail: (input: JQuery): boolean => {
                     if (input.attr("name") !== "ExpediteurEmail")
                         return true;
                     const value = (input.val() as string ?? "").trim();
                     if (value.length === 0)
                         return true;
                     return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
                 },
                 messages: {
                     expediteurEmail: "L'e-mail de l'expéditeur est invalide."
                 }
             },
             editorOptions: {
                 size: "small"
             }
         }, {
             field: "ExpediteurNom",
             label: "Nom expéditeur (par défaut)",
             validation: {required: false},
             editorOptions: {
                 size: "small"
             }
         }],
         validate : (e: kendo.ui.FormValidateEvent) => {
             this.#isValid = e.valid;
         },
         // Le modèle reçu est le proxy partagé du DirtyTracker : écrire
         // directement le champ qui change suffit à marquer le modèle dirty et
         // à le faire remonter à la sauvegarde. (Chaque champ écrit SA clé : pas
         // de réécriture globale de SubjectTemplate — bug corrigé.)
         change : (e: kendo.ui.FormChangeEvent) => {
             this.#model[e.field] = e.value;
         }

     }).data("kendoForm");   
     
     this.#formRemoveButton().then();
    }

    #formRemoveButton = async () => {
        this.#kForm.element.find(".k-form-buttons").remove();
    }

    /// <summary>
    /// Déclenche la validation Kendo du formulaire (affiche les messages) et
    /// renvoie la validité. À appeler avant la sauvegarde pour bloquer un
    /// expéditeur invalide côté UI (le back valide aussi, en dernier rempart).
    /// </summary>
    public Validate = (): boolean => {
        // kendoForm.validate() renvoie un booléen à l'exécution mais est typé
        // void dans les définitions locales : on cast explicitement.
        this.#isValid = (this.#kForm.validate() as unknown as boolean) ?? this.#isValid;
        return this.#isValid;
    }
    
    public Dispose = async () => {
       this.#kForm.destroy();
       this.#jqFormContainer.remove();
       this.#jqMainContainer.empty();
    }
}

export interface ITemplateSujetEditor {
    jqMainContainer: JQuery;
    model : ITemplateModel
}